import i18n from "./index";
import { withEnglishQuery, type AppLocale } from "./locale";

/** Append lang=en when the active locale is English. */
export function localizeShareUrl(url: string): string {
  const locale: AppLocale = i18n.language?.startsWith("en") ? "en" : "es";
  return withEnglishQuery(url, locale);
}
